import { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import {
    BoxContainer,
    BoxTitle,
    BoxHead,
    Underline,
} from "../../Components/Styles/PageStyles";
import { useSelector } from "react-redux";
import { useMutation, useQuery } from "react-query";
import axios from "axios";
import Config from "../../Config";
import { toast } from "react-toastify";
import Loading from "../../Components/Loading";
import NotFoundModel from "../../Components/NotFoundModel";
import ElectricityBillTable from "../../Components/Properties/ElectricityBillTable";
import { useLocation, useNavigate } from "react-router-dom";
import SideModal from "../../Components/SideModal";
import AddElectricityBill from "../../Components/Properties/AddElectricityBill";
import { IoChevronBackOutline } from "react-icons/io5";


const ElectricityBill = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const propertyDetails = location.state?.propertyDetails;
    const propertyId = propertyDetails?.id;
    const type = propertyDetails?.type;
    const user = useSelector((state) => state.UserReducer.user);
    const [showElectricitybill, setShowElctricityBill] = useState(false);
    const [apiData, setApiData] = useState();
    const fetchFunction = async () => {
        const response = await axios.get(
            `${Config.apiUrl}/electricity/list/${propertyId}/${type}`,
            {
                headers: {
                    authorization: "Bearer" + " " + user.token,
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                },
            }
        );
        return response.data;
    };

    const getSuccess = (res) => {
        if (res.isSuccess === false) error = true;
        else {
            setApiData(res?.data);
            //setSummary(res?.stats);
        }
    };

    const getError = (res) => { };

    const {
        isLoading: isLoading,
        mutate: getListMutate,
        error,
        data,
        isRefetching,
        refetch,
    } = useMutation(fetchFunction, {
        onSuccess: getSuccess,
        onError: getError,
    });

    useEffect(() => {
        const handler = setTimeout(() => {
            getListMutate();
        }, 500);

        return () => {
            clearTimeout(handler);
        };
    }, [propertyId]);

    const handleCloseAddBillModal = () => {
        setShowElctricityBill(false);
    };

    //------- Add electricity bill Model -------
    const AddElectricityBillFunction = async (values) => {
        return await axios.post(`${Config.apiUrl}/electricity/add`, values, {
            headers: {
                "Content-Type": "application/json",
                authorization: `Bearer ${user.token}`,
            },
        });
    };

    const addElectricityBillSuccess = (data) => {
        setShowElctricityBill(false);
        getListMutate();
        toast.success(data?.data?.msg || "Success");
    };

    const addElectricityBillError = (data) => {
        toast.error(data?.response?.data?.msg || "An Error Occured");
    };

    const { isLoading: addBillLoading, mutate: addBillMutate } =
        useMutation(AddElectricityBillFunction, {
            onSuccess: addElectricityBillSuccess,
            onError: addElectricityBillError,
        });

    return (
        <BoxContainer>
            <BoxHead>
                <BoxTitle className="!mb-0 whitespace-nowrap">
                    <div className="flex cursor-pointer" onClick={() => navigate(-1)}>
                        <span className="hover:bg-gray-200 items-center pt-[5px]">
                            <IoChevronBackOutline
                                size={20}
                            //className="text-primary-color"
                            />
                        </span>
                        <div>
                            <span className="flex items-center cursor-pointer">
                                Electricity Bill
                            </span>
                            <Underline />
                        </div>
                    </div>
                </BoxTitle>
                {data && !error && !isLoading &&
                    <ApplyBtn
                        type="button"
                        onClick={() => {
                            setShowElctricityBill(true);
                        }}
                    >
                        {"Add Bill"}
                    </ApplyBtn>}
            </BoxHead>
            <SideModal
                isOpen={showElectricitybill}
                onClose={handleCloseAddBillModal}
            >
                <AddElectricityBill
                    data={data}
                    handleClose={handleCloseAddBillModal}
                    propId={propertyId}
                    type={type}
                    addBillMutate={addBillMutate}
                    addBillLoading={addBillLoading}
                    propertyDetails={propertyDetails}
                />
            </SideModal>

            {!error && !isLoading && data && (
                <TableWrapper>
                    <ElectricityBillTable
                        apiData={error ? [] : apiData}
                        type={type}
                        propName={propertyDetails?.name || ''}
                    />
                    {(error || apiData.length === 0) && !isLoading && (
                        <NotFoundModel msg={"No Electricity Bill Generated Yet."} />
                    )}
                </TableWrapper>
            )}
            {(isLoading || isRefetching) && <Loading />}
        </BoxContainer>
    );
};

const TableWrapper = tw.h1`my-8 border  bg-white rounded-md `;
const ApplyBtn = tw.button`${(p) =>
    p.$active
        ? "bg-gray-100"
        : ""} border whitespace-nowrap border-gray-200 flex space-x-1.5 justify-center items-center text-white h-full rounded-md px-6  cursor-pointer bg-primary-color hover:bg-hover-color  py-2.5 text-sm`;

export default ElectricityBill;
